import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/contexts/AuthContext";
import { PurchasePriceProvider } from "@/contexts/PurchasePriceContext";
import { NotificationProvider } from "@/contexts/NotificationContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import ErrorBoundary from "@/components/feature/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <I18nextProvider i18n={i18n}>
          <AuthProvider>
            <PurchasePriceProvider>
              <NotificationProvider>
                <BrowserRouter basename={__BASE_PATH__}>
                  <AppRoutes />
                </BrowserRouter>
              </NotificationProvider>
            </PurchasePriceProvider>
          </AuthProvider>
        </I18nextProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;